import Vue from 'vue'
import { Row, Col, Button, ButtonGroup } from 'element-ui'

import 'element-ui/lib/theme-chalk/display.css'

Vue.use(Row)
Vue.use(Col)
Vue.use(Button)
Vue.use(ButtonGroup)
